import React from "react";
import ClassBoardPicker from "../../../../../components/montessori-course-board/ClassBoardPicker";

/** Admin entry point — every class in the school has a board. */
function AdminCourseBoardMain() {
  return (
    <ClassBoardPicker
      source="all"
      basePath="/dashboard/admin/menu/course-board/class"
    />
  );
}

export default AdminCourseBoardMain;
